import { createSlice } from "@reduxjs/toolkit";

import { ROLES, uccAdmin } from "../../../components/helpers/constants";
import {
  encryptPayload,
  getObjLength,
  markLoginSessionFresh,
  markSignupSessionComplete,
  persistPropertySearchAndBillingPrefillFromReport,
  persistSignupAccountBillingNames,
  reactPixelEvent,
  setStanupPopupCountIfEligible,
} from "../../../components/helpers/utils";

const intialUserSignInState = {
  userSignInDetails: {},
  forgotPasswordDetails: {},
  otpVerifyDetails: {},
  resetPasswordInfo: {},
  resetPasswordLoader: false,
  resetPasswordDetails: {},
  emailForResetPass: {},
  userCredentials: {},
  sendOTPResponse: {},
  optVerification: {},
  resendOTP: {},
  verifyFace: {},
  canUserLogin: false,
  selectedOption: "",
  ssoDetails: {},
  sso_Loader: false,
  forgotPasswordLoader: false,
  emailFreeMonitoringDetails: {},
  propertyStatusDetails: {},
  propertyFlagResponseDetails: {},
  propertyFlagResponseLoader: false,
};

const signInUser = createSlice({
  name: "userSignInDetails",
  initialState: intialUserSignInState,
  reducers: {
    userSignInData(state, action) {
      console.log("login data==>>", action.payload);
      state.userCredentials = action.payload?.data;
    },
    setUserCredentials(state, action) {
      console.log("login data==>>", action.payload);
      state.userCredentials = action.payload;
    },
    fetchUserData(state, action) {
      console.log("In state slice...", action.payload);
      state.userSignInDetails = action.payload;
      if (action.payload?.success) {
        if (action.payload.data?.role?.includes(ROLES.customer)) {
          reactPixelEvent("SignIn", { email: state.userCredentials?.email });
        }
        if (uccAdmin === action.payload?.data?.user?.email) {
          localStorage.setItem("ucc_Allowed_Admin", encryptPayload("true"));
        } else {
          localStorage.removeItem("ucc_Allowed_Admin");
        }
        if (action.payload.data?.investor_id) {
          localStorage.setItem("investor_id", action.payload.data?.investor_id);
        } else {
          localStorage.removeItem("investor_id");
        }
        if (action.payload.data?.county_user_id) {
          localStorage.setItem(
            "county_user_id",
            action.payload.data?.county_user_id,
          );
        } else {
          localStorage.removeItem("county_user_id");
        }
      }
      if (
        action.payload?.success &&
        action.payload.data?.AccessToken
      ) {
        localStorage.setItem("authToken", action.payload.data.AccessToken);
        localStorage.setItem("authorised", "true");
        markLoginSessionFresh();
        if (
          typeof window !== "undefined" &&
          !window.location.pathname.includes("create-account")
        ) {
          markSignupSessionComplete();
        }
      }
      if (action.payload?.data?.role === "Professional") {
        localStorage.setItem("authToken", action.payload.data?.AccessToken);
        localStorage.setItem("authorised", action.payload.success);
        localStorage.setItem("paymentPopup", 0);
        localStorage.setItem("stanupPopupCount", 1);
        document.cookie =
          "professioanlCookie =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      const roles = action.payload?.data?.roles;
      if (Array.isArray(roles) && roles.length) {
        localStorage.setItem("userRoles", JSON.stringify(roles));
        if (action.payload.data.default_portal) {
          localStorage.setItem(
            "defaultPortal",
            action.payload.data.default_portal,
          );
        }
        if (roles.length === 1) {
          localStorage.setItem("activeRole", roles[0]);
          localStorage.setItem("roles", encryptPayload(roles[0]));
        }
      } else if (action.payload?.data?.role) {
        localStorage.setItem(
          "roles",
          encryptPayload(action.payload?.data?.role),
        );
      } else if (action?.payload?.data?.user?.user_type?.[0]) {
        localStorage.setItem(
          "roles",
          encryptPayload(action?.payload?.data?.user?.user_type?.[0]),
        );
      }
      if (action.payload.data?.category) {
        localStorage.setItem(
          "category",
          encryptPayload(action.payload.data?.category),
        );
      }

      persistSignupAccountBillingNames(action.payload?.data || {});

      if (getObjLength(action.payload.data?.report_details)) {
        persistPropertySearchAndBillingPrefillFromReport(
          action.payload.data.report_details,
        );
      } else {
        localStorage.setItem("plain_signup", "true");
      }
      // localStorage.setItem("authToken", action.payload.data?.AccessToken);
    },
    forgotPassword(state, action) {
      console.log("forgotPass data==>>", action.payload);
      state.emailForResetPass = action.payload?.data;
      state.selectedOption = action.payload?.selectedOption;
      state.forgotPasswordLoader = true;
    },
    forgotPasswordData(state, action) {
      console.log("In ForgotPass state slice...", action.payload);
      state.forgotPasswordDetails = action.payload;
      if (Object.keys(state.resetPasswordDetails).length > 0) {
        state.resetPasswordDetails = {};
      }
      state.forgotPasswordLoader = false;
    },
    otpVerifyData(state, action) {
      console.log("In otpVerifyDetails state slice...", action.payload);
      state.otpVerifyDetails = action.payload;
    },
    resetPassword(state, action) {
      console.log("Reset password data==>>", action.payload);
      state.resetPasswordInfo = action.payload?.data;
      state.resetPasswordLoader = true;
      state.forgotPasswordDetails.message = "";
    },
    resetPasswordData(state, action) {
      console.log("In Reset Password state slice...", action.payload);
      if (action.payload?.success) {
        reactPixelEvent("Reset Password", {
          email: state.resetPasswordInfo?.email,
        });
      }
      state.resetPasswordDetails = action.payload;
      state.resetPasswordLoader = false;
    },
    clearResetPasswordData(state, action) {
      console.log("In Clear Reset Password state slice...");
      state.resetPasswordDetails = {};
      state.forgotPasswordDetails = {};
    },
    sendOTPData(state, action) {
      console.log("send OTP data==>>", action.payload);
      state.optVerification = {};
    },
    sendOTPResponse(state, action) {
      console.log("send OTP responese ==>>", action.payload);
      state.sendOTPResponse = action.payload;
    },
    userVerifyOTP(state, action) {
      console.log("send OTP data==>>", action.payload);
      state.optVerification = {};
    },
    verifyOTPResponse(state, action) {
      console.log("send OTP responese ==>>", action.payload);
      state.optVerification = action.payload;
      if (action.payload?.success && action.payload.data?.AccessToken) {
        localStorage.setItem("authToken", action.payload.data.AccessToken);
        localStorage.setItem("authorised", "true");
        if (
          typeof window !== "undefined" &&
          !window.location.pathname.includes("create-account")
        ) {
          markSignupSessionComplete();
        }

        const roles = action.payload?.data?.roles;
        if (Array.isArray(roles) && roles.length) {
          localStorage.setItem("userRoles", JSON.stringify(roles));
          if (action.payload.data.default_portal) {
            localStorage.setItem(
              "defaultPortal",
              action.payload.data.default_portal,
            );
          }
          if (roles.length === 1) {
            localStorage.setItem("activeRole", roles[0]);
            localStorage.setItem("roles", encryptPayload(roles[0]));
          }
        } else if (action.payload?.data?.role) {
          localStorage.setItem(
            "roles",
            encryptPayload(action.payload?.data?.role),
          );
        }
      }
    },
    resendOTP(state, action) {
      console.log("send OTP data==>>", action.payload);
      // state.optVerification={};
    },
    resendResponse(state, action) {
      console.log("send OTP responese ==>>", action.payload);
      state.resendOTP = action.payload;
      state.optVerification = {};
    },
    successLogout(state, action) {
      state.userSignInDetails = {};
      state.forgotPasswordDetails = {};
      state.otpVerifyDetails = {};
      state.resetPasswordDetails = {};
      state.emailForResetPass = {};
      state.userCredentials = {};
      state.sendOTPResponse = {};
      state.optVerification = {};
      state.resendOTP = {};
    },
    getVerifyFace(state, action) {
      console.log("Verify-face==>>", action.payload);
    },
    fetchVerifyFace(state, action) {
      console.log("fetch verify Face slice..", action.payload);
      state.verifyFace = action.payload;
      localStorage.setItem("authToken", action.payload.data?.AccessToken);
      localStorage.setItem("authorised", action.payload.success);

      const roles = action.payload?.data?.roles;
      if (Array.isArray(roles) && roles.length) {
        localStorage.setItem("userRoles", JSON.stringify(roles));
        if (action.payload.data.default_portal) {
          localStorage.setItem(
            "defaultPortal",
            action.payload.data.default_portal,
          );
        }
        if (roles.length === 1) {
          localStorage.setItem("activeRole", roles[0]);
          localStorage.setItem("roles", encryptPayload(roles[0]));
        }
      } else if (action.payload?.data?.role) {
        localStorage.setItem("roles", encryptPayload(action.payload?.data?.role));
      }
    },
    clearStoreData(state, action) {
      state.userSignInDetails = {};
      state.forgotPasswordDetails = {};
      state.otpVerifyDetails = {};
      state.resetPasswordDetails = {};
      state.emailForResetPass = {};
      state.userCredentials = {};
      state.sendOTPResponse = {};
      state.optVerification = {};
      state.resendOTP = {};
      state.verifyFace = {};
      // localStorage.setItem("authToken", null);
    },
    getSSOData(state, action) {
      state.sso_Loader = true;
    },
    fetchSSODetails(state, action) {
      console.log("ssoDetails==>> slice", action.payload);
      state.sso_Loader = false;
      state.ssoDetails = action?.payload;
      if (action?.payload?.success) {
        localStorage.setItem("preference", true);
        localStorage.setItem("authToken", action.payload.data?.AccessToken);
        localStorage.setItem("authorised", action.payload.success);
        localStorage.setItem("roles", encryptPayload(ROLES.customer));
        localStorage.setItem("paymentPopup", 0);
        setStanupPopupCountIfEligible(action.payload.data?.category ?? action.payload.data?.user?.product_tier);
      }
    },
    getEmailFreeMonitoringData(state, action) {
      state.sso_Loader = true;
    },
    fetchEmailFreeMonitoringDetails(state, action) {
      state.sso_Loader = false;
      state.emailFreeMonitoringDetails = action?.payload;
      if (action?.payload?.success) {
        localStorage.setItem("preference", true);
      }
    },
    getProeprtyStatusData(state, action) {
      state.sso_Loader = true;
    },
    fetchPropertyStatusDetails(state, action) {
      state.sso_Loader = false;
      state.propertyStatusDetails = action?.payload;
      if (action?.payload?.success) {
        localStorage.setItem("preference", true);
      }
    },
    submitPropertyFlagResponse(state) {
      state.propertyFlagResponseLoader = true;
    },
    setPropertyFlagResponse(state, action) {
      state.propertyFlagResponseLoader = false;
      state.propertyFlagResponseDetails = action?.payload;
    },
    clearPropertyFlagResponse(state) {
      state.propertyFlagResponseDetails = {};
      state.propertyFlagResponseLoader = false;
    },
  },
});
export const userSigInAction = signInUser.actions;
export default signInUser.reducer;
